const ZONE = "America/New_York"

const formatter = new Intl.DateTimeFormat("en-US", {
  timeZone: ZONE,
  year: "numeric",
  month: "long",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  hour12: true,
  timeZoneName: "short",
})

export const formatCastingCallDate = (iso: string): string =>
  formatter
    .formatToParts(new Date(iso))
    .map((part) =>
      part.type === "literal" && part.value === " at " ? " " : part.value
    )
    .join("")
    // Intl uses narrow no-break spaces (U+202F) around the AM/PM marker on
    // some platforms; normalize so the rendered string is plain ASCII.
    .replace(/ /g, " ")
